/* CSS */
import "@css/app.pcss";

/* JS */
import ApexCharts from 'apexcharts';
window.ApexCharts = ApexCharts;

import flatpickr from 'flatpickr';
window.flatpickr = flatpickr;

import { GridStack } from 'gridstack';
window.GridStack = GridStack;

// Complete SortableJS (with all plugins)
import Sortable from 'sortablejs';
window.Sortable = Sortable;
/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
import Clipboard from '@ryangjchandler/alpine-clipboard';
import Tooltip from '@ryangjchandler/alpine-tooltip';
import focus from '@alpinejs/focus';
import anchor from '@alpinejs/anchor';
import intersect from '@alpinejs/intersect'

import iframeResize from 'iframe-resizer/js/iframeResizer';

// Make sure Alpine has access to flatpickr
document.addEventListener('alpine:init', () => {
    Alpine.magic('flatpickr', () => {
        return window.flatpickr;
    });

    Alpine.magic('Sortable', () => {
        return window.Sortable;
    });
});

Alpine.plugin(Clipboard);
Alpine.plugin(Tooltip);
Alpine.plugin(focus);
Alpine.plugin(anchor);
Alpine.plugin(intersect);

window.Alpine = Alpine;
Alpine.start();